import ChloromanceTracker from '../../pages/ChloromanceTracker/ChloromanceTracker';
import './MobileApp.css';
import React from 'react';
import ChloromanceAuthGate from '../../components/Chloromance/ChloromanceAuthGate';

function MobileApp() {
  return (
    <ChloromanceAuthGate sessionBarPlacement="bottom">
      {(user, openPrivacy) => (
        <div className="mobile-app-shell">
          <ChloromanceTracker userId={user.id} onOpenPrivacy={openPrivacy} />
        </div>
      )}
    </ChloromanceAuthGate>
  );
}

export default MobileApp;
